/**
 * SD-7431: Represents an action that can be triggered when a user clicks on an inline element.
 *
 * @interface InlineClickAction
 */
export type InlineClickAction = {
	type?: string;
	url?: string;
	postback?: string;
	postbackAction?: string;
	replyText?: string;
	settings?: any;
	metadata?: any;
	property?: string;
	propertyValue?: number | string;
};

/**
 * SD-8338: Represents an analytic payload that can be triggered when a user clicks on an inline element.
 *
 * @interface InlineClickAnalyticPayload
 */

export type InlineClickAnalyticPayload = {
	conversationId: string;
	linkText: string;
	linkUrl: string;
};
